<ng-container *ngIf="state$ | async as state">
  <button *ngIf="backgroundColor"
          (click)="close()"
          aria-label="Close"
          class="close infographic-modal-close"
          data-cy="image-carousel-modal-close-button"
          data-dismiss="modal"
          type="button"
  >
        <span aria-hidden="true"
              data-cy="image-carousel-modal-close-text"
              [innerHTML]="'×'"
        ></span>
  </button>
  <div *ngIf="state.data.viewportImages"
       [class.carousel-buttons]="useCarouselButtons"
       [id]="'imageCarousel-' + id"
       class="carousel slide"
       data-cy="image-carousel"
       data-ride="carousel"
  >
    <div [attr.aria-label]="state.data.viewportImages[state.currentSlide]?.caption?.value?.trim()?.length ? undefined : 'image'"
         [class.mg-5]="!state.data.viewportImages[state.currentSlide]?.caption?.value"
         class="modal-header modal-padding"
         [class]="backgroundColor ? 'bg-' + backgroundColor : ''"
         data-cy="image-carousel-modal-header"
    >
      <button *ngIf="!backgroundColor"
              (click)="close()"
              aria-label="Close"
              class="close"
              data-cy="image-carousel-modal-close-button"
              data-dismiss="modal"
              type="button"
      >
        <span aria-hidden="true"
              data-cy="image-carousel-modal-close-text"
              [innerHTML]="'×'"
        ></span>
      </button>
      <div *ngIf="state.data.viewportImages[state.currentSlide]?.caption?.value?.trim()?.length"
           [data-preview-id]="'#' + state.data.viewportImages[state.currentSlide]?.caption?.name"
           [id]="'headline-' + id"
           [innerHTML]="state.data.viewportImages[state.currentSlide]?.caption?.value | safeHtml"
           class="modal-title"
           data-cy="image-carousel-modal-headline"
           mbCmsInnerHTML
      ></div>
    </div>
    <div class="modal-body modal-padding"
         [class]="backgroundColor ? 'bg-' + backgroundColor : ''"
         data-cy="image-carousel-modal-body"
    >
      <div class="wrapper">
        <ngb-carousel [activeId]="'slide-' + start"
                      [interval]="0"
                      [showNavigationIndicators]="false"
                      (slide)="onSlide($event)"
                      #carousel
        >
          <ng-template *ngFor="let image of state.images; index as i"
                       [attr.id]="'slide-' + i"
                       ngbSlide
          >
            <mb-picture [img]="image?.image"
                        [srcSet]="[{ mediaQuery: mediaQuery.MIN_WIDTH_1200, url1x: image.image?.xl, url2x: image.image?.xl2x },
                                   { mediaQuery: mediaQuery.MIN_WIDTH_992, url1x: image.image?.lg, url2x: image.image?.lg2x },
                                   { mediaQuery: mediaQuery.MIN_WIDTH_768, url1x: image.image?.md, url2x: image.image?.md2x },
                                   { mediaQuery: mediaQuery.MIN_WIDTH_500, url1x: image.image?.sm, url2x: image.image?.sm2x },
                                   { mediaQuery: mediaQuery.MAX_WIDTH_499, url1x: image.image?.xs, url2x: image.image?.xs2x }]"
                        dataCy="gallery-item-image"
            >
              <div *ngIf="!useCarouselButtons"
                   class="nav-overlay"

              >
                <mb-link [linkData]="{uid: cmsLinkType.SPECIAL}"
                         [useSlot]="true"
                         (clickEvent)="slideLeft()"
                         dataCy="arrow-left"
                         style="width: 50%; display: flex;"
                         [styleClass]="['arrow','arrow-left']"
                >
                  <span class="arrow-left">
                    <img [alt]="'shared.arrowLeft' | cxTranslate"
                         [title]="'shared.arrowLeft' | cxTranslate"
                         class="arrow-left"
                         height="60px"
                         src="/assets/images/Icon_arrow-left_white.svg"
                         width="16px"
                    >
                  </span>
                </mb-link>
                <mb-link [linkData]="{uid: cmsLinkType.SPECIAL}"
                         [useSlot]="true"
                         (clickEvent)="slideRight()"
                         dataCy="arrow-right"
                         style="width: 50%; display: flex;"
                         [styleClass]="['arrow','arrow-right']"
                >
                  <span class="arrow-right">
                    <img [alt]="'shared.arrowRight' | cxTranslate"
                         [title]="'shared.arrowRight' | cxTranslate"
                         class="arrow"
                         height="60px"
                         src="/assets/images/Icon_arrow-right_white.svg"
                         width="16px"
                    >
                  </span>
                </mb-link>
              </div>
              <div *ngIf="useCarouselButtons"
                   class="carousel-controls"
              >
                <mb-link *ngIf="state.currentSlide !== 0"
                         [linkData]="{uid: cmsLinkType.SPECIAL}"
                         [useSlot]="true"
                         (clickEvent)="carousel?.prev()"
                         role="button"
                         styleClass="carousel-control-prev"
                >
                  <span class="sr-only">Previous</span>
                </mb-link>
                <mb-link *ngIf="state.currentSlide < state.images.length - 1"
                         [linkData]="{uid: cmsLinkType.SPECIAL}"
                         [useSlot]="true"
                         (clickEvent)="carousel?.next()"
                         role="button"
                         styleClass="carousel-control-next"
                >
                  <span class="sr-only">Next</span>
                </mb-link>
              </div>
              <div *ngIf="showCarouselIndicators"
                   class="indicators"
              >
                <ol class="carousel-indicators"
                    role="tablist"
                >
                  <li *ngFor="let image of state.images; index as i"
                      [attr.aria-selected]="i === state.currentSlide"
                      [class.active]="i === state.currentSlide"
                      (click)="setSelectedSlide(i)"
                      role="tab"
                  ></li>
                </ol>
              </div>
              <div *ngIf="useCarouselButtons"
                   class="carousel-controls"
              >
                <a *ngIf="state.currentSlide !== 0"
                   (click)="carousel?.prev()"
                   class="carousel-control-prev"
                   role="button"
                >
                  <span class="sr-only">Previous</span>
                </a>
                <a *ngIf="state.currentSlide < state.images.length - 1"
                   (click)="carousel?.next()"
                   class="carousel-control-next"
                   role="button"
                >
                  <span class="sr-only">Next</span>
                </a>
              </div>
              <div *ngIf="showCarouselIndicators"
                   class="indicators"
              >
                <ol class="carousel-indicators"
                    role="tablist"
                >
                  <li *ngFor="let image of state.images; index as i"
                      [attr.aria-selected]="i === state.currentSlide"
                      [class.active]="i === state.currentSlide"
                      (click)="setSelectedSlide(i)"
                      role="tab"
                  ></li>
                </ol>
              </div>
            </mb-picture>
          </ng-template>
        </ngb-carousel>
      </div>
    </div>
  </div>
  <div class="modal-footer"
       data-cy="image-carousel-modal-footer"
  >
    <div *ngIf="state.data.viewportImages[state.currentSlide]?.description?.value?.length || backgroundColor?.length"
         [data-preview-id]="'#' + state.data.viewportImages[state.currentSlide]?.description?.name"
         [id]="'description-' + id"
         [innerHTML]="state.data.viewportImages[state.currentSlide]?.description?.value | safeHtml"
         data-cy="image-carousel-modal-description"
         class="footer-container"
         [class]="backgroundColor ? 'bg-' + backgroundColor : ''"
         mbCmsInnerHTML
    ></div>
  </div>
</ng-container>
